<template>
  <div class="dev-downloads">
    <div class="dev-downloads-content">
      <Collapse title="Descargas" :settings="{ opened: true }">
        <Download v-for="(item, index) in downloads" :key="index" :download="item.data" />
      </Collapse>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Download: () => import("./Download.vue"),
  },
  methods: {
    getDownloads: async function({ page = 1 } = {}) {
      try {
        const res = await this.$api.get(`/dev/downloads?page=${page}`);
        this.$store.state.downloads.items = res.data.items;
        this.$store.state.downloads.latest = res.data.items[0];
      } catch (error) {}
    },
  },
  mounted: function() {
    this.getDownloads();
  },
  computed: {
    downloads: function() {
      return this.$store.state.downloads.items;
    },
  },
};
</script>
